const ITEMS = [
  "Figuratif",
  "Abstrait",
  "Pop art",
  "Art urbain",
  "Monumental",
  "Bronze",
  "Résine",
  "Cire perdue",
  "Taille directe",
  "Patine",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-ink/10 bg-cream py-5"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-2xl italic text-ink/70 sm:text-3xl">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-bronze" />
          </span>
        ))}
      </div>
    </div>
  );
}
